import React from "react";
import { LoginPage } from "./LoginPage";

export const AuthPage: React.FC = () => {
  return <LoginPage />;
};
